import { Link } from 'react-router-dom';
import type { FC } from 'react';
import { features } from '@/mocks/data';

const FeatureSection: FC = () => {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
            核心功能一览
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            17c.com 为您提供全方位的数字化服务能力，满足个人和团队的多样化需求
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {features.map((feature, index) => (
            <Link
              key={index}
              to="/category/features"
              className="group p-6 md:p-7 bg-background-50 border border-background-200/70 rounded-lg hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="w-11 h-11 flex items-center justify-center rounded-md bg-primary-50 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors duration-300">
                <i className={`${feature.icon} text-xl`} />
              </div>
              <h3 className="mt-4 text-base font-semibold text-foreground-950 font-label">
                {feature.title}
              </h3>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
                {feature.description}
              </p>
            </Link>
          ))}
        </div>

        <div className="mt-10 text-center">
          <Link
            to="/category/features"
            className="inline-flex items-center gap-2 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap"
          >
            查看全部功能
            <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default FeatureSection;